import React, { useState, useLayoutEffect } from 'react';
import { Link } from 'react-router-dom';
import { Navbar, Nav, Container } from 'react-bootstrap';
import './style/Header.css';

const Header = () => {
  // State to manage the toggle of the navbar
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 991);

  const toggleNavbar = () => {
    if (isSmallScreen) {
      setIsNavOpen(!isNavOpen);
    }
  };

  // Handle window resize and reset burger menu state
  useLayoutEffect(() => {
    const handleResize = () => {
      const isCurrentlySmallScreen = window.innerWidth <= 991;
      setIsSmallScreen(isCurrentlySmallScreen);

      // Close the menu when the screen becomes large
      if (!isCurrentlySmallScreen) {
        setIsNavOpen(false); // Close menu immediately on screen resize
      }
    };

    window.addEventListener('resize', handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <header className="header">
      <Navbar expand="lg" sticky="top">
        <Container className="navbar-container">
          <Link
            to="/"
            className={`navbar-logo ${isNavOpen ? 'sticky-logo' : ''}`}
          >
            <img
              src="/assets/logo-studio-vinzaglio.jpg"
              alt="Logo"
              className="logo-img"
            />
          </Link>

          {/* Navbar Toggle for mobile */}
          <Navbar.Toggle aria-controls="navbar-nav" onClick={toggleNavbar} />

          {/* Navbar Links */}
          <Navbar.Collapse
            id="navbar-nav"
            in={isNavOpen}
            className={isSmallScreen ? 'header__nav--open' : ''}
          >
            <Nav className="ms-auto">
              <Nav.Item>
                <Nav.Link
                  as={Link}
                  to="/"
                  className="nav-link"
                  onClick={toggleNavbar}
                >
                  Home
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  as={Link}
                  to="/cosa-facciamo"
                  className="nav-link"
                  onClick={toggleNavbar}
                >
                  Cosa facciamo
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  as={Link}
                  to="/chi-siamo"
                  className="nav-link"
                  onClick={toggleNavbar}
                >
                  Chi siamo
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  as={Link}
                  to="/contatti"
                  className="nav-link"
                  onClick={toggleNavbar}
                >
                  Contatti
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
